import { observer } from 'mobx-react-lite'
import { Button, EnumHelperText, HelperText, Label, SectionCollapse } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { CategoryMessage } from 'pages/surveys/ui/SurveyView/ui/CategoryMessage/CategoryMessage'
import { SurveySwitch } from 'pages/surveys/ui/SurveySwitch/SurveySwitch'
import type { ClosingMessageStore } from './store/closingMessageStore'
import styles from './styles.module.scss'

type IClosingMessageProps = {
  store: ClosingMessageStore
}

export const ClosingMessage = observer(({ store }: IClosingMessageProps) => (
  <SectionCollapse icon='checkVerified' title='Closing message' error={store.sectionError}>
    <div className={styles.container}>
      <SurveySwitch label={'Closing message'} active={store.enabled} onToggle={store.setEnabled} />
      {store.enabled && (
        <>
          {!store.perGroupEnabled && (
            <div className={styles.messageBlock}>
              <Label
                marginBottom={1}
                label={{
                  text: 'Message',
                  rightNode: store.isModified ? (
                    <Button
                      text='Revert to default'
                      typeBtn='link'
                      contained='primary'
                      size='small'
                      onClick={store.revertToDefault}
                    />
                  ) : null,
                }}
              />
              <MessageField messageFieldStore={store.messageFieldStore} />
              {store.error && (
                <div className={styles.error}>
                  <HelperText
                    icon={'alertTriangleSmall'}
                    variant={EnumHelperText.Error}
                    text={store.error}
                  />
                </div>
              )}
            </div>
          )}
          <SurveySwitch
            label={'Different message based on response'}
            active={store.perGroupEnabled}
            onToggle={store.setPerGroupEnabled}
            tooltipProps={{
              label:
                'Send a different message based on score. At least one response group needs a message.',
              placement: 'top',
              breakWord: true,
              maxWidth: 260,
            }}
          />
          {store.perGroupEnabled && (
            <div className={styles.categories}>
              <CategoryMessage store={store.promoters} label='Promoters (9-10)' dotColor='green' />
              <CategoryMessage store={store.passives} label='Passives (7-8)' dotColor='orange' />
              <CategoryMessage store={store.detractors} label='Detractors (0-6)' dotColor='red' />
              {store.error && (
                <div className={styles.error}>
                  <HelperText
                    icon={'alertTriangleSmall'}
                    variant={EnumHelperText.Error}
                    text={store.error}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  </SectionCollapse>
))
